import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { ref } from '@netbasequid/theme'
import { useSysTheme, useDisplayTheme } from 'hooks/useUiState'
import { getFloatNumberInfo } from '../utils'

const CircleContainer = styled.div`
  display: flex;
  gap: 6px;
`

const SolidCircle = styled.div<{ color?: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`
const LinearedCircle = styled(SolidCircle)<{
  percent: number
  fillColor: string
  bgColor: string
}>`
  background: linear-gradient(
    to right,
    ${({ fillColor }) => fillColor} 0 ${({ percent }) => percent}%,
    ${({ bgColor }) => bgColor} ${({ percent }) => percent}% 100%
  );
`

const SurveyScore = ({ value, maxValue }: { value: number; maxValue: number }) => {
  const theme = useSysTheme()
  const mode = useDisplayTheme()
  const { floorValue, pointValue } = getFloatNumberInfo(value)

  const hasPoint = pointValue !== 0

  const filledStars = Array(floorValue > 0 ? floorValue : 0).fill(0)
  const emptyStars = Array(maxValue - filledStars.length - (hasPoint ? 1 : 0)).fill(0)

  return (
    <CircleContainer>
      {filledStars.map((_, index) => (
        <SolidCircle
          /* eslint-disable-next-line react/no-array-index-key */
          key={index}
          color={mode === 'light' ? ref.color.fuchsia[600] : ref.color.fuchsia[400]}
        />
      ))}
      {hasPoint && (
        <LinearedCircle
          percent={pointValue * 10}
          fillColor={mode === 'light' ? ref.color.fuchsia[600] : ref.color.fuchsia[400]}
          bgColor={theme.common.divider[100]}
        />
      )}
      {emptyStars.map((_, index) => (
        /* eslint-disable-next-line react/no-array-index-key */
        <SolidCircle key={index} color={theme.common.divider[100]} />
      ))}
    </CircleContainer>
  )
}

export default SurveyScore
